import { hr } from '@src/service/locale/antd/hr';
import en_US from 'antd/lib/locale/en_US';

export const ANTDLOCALES = {
  hr,
  en: en_US,
} as any;
